// src/components/MailMarketing.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MailMarketing.css';

const MailMarketing = () => {
  const navigate = useNavigate();
  return (
    <div className="mail-marketing">
      <div className="mail-header">
        <h1>Mail Marketing</h1>
        <button onClick={() => navigate('/admin')} className="back-admin-button">
          Back to Admin
        </button>
      </div>

      <div className="workflow-section">
        <div className="workflow-intro">
          <h2>Choose Your Target Audience</h2>
          <p>Select how you'd like to choose recipients for your mail campaign</p>
        </div>

        <div className="workflow-options">
          <div className="workflow-card" onClick={() => navigate('/admin/mail-marketing/contacts')}>
            <div className="workflow-icon">📋</div>
            <h3>Select from Contacts</h3>
            <p>Choose from your existing contact database</p>
            <div className="workflow-arrow">→</div>
          </div>

          <div className="workflow-card" onClick={() => navigate('/admin/mail-marketing/map')}>
            <div className="workflow-icon">🗺️</div>
            <h3>Select Address from Map</h3>
            <p>Target specific geographic areas and addresses</p>
            <div className="workflow-arrow">→</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailMarketing;
